
import { Component, Ref, Vue } from 'vue-property-decorator'
import ModalMessage from '@/components/templates/ModalMessage.vue'

/**
 * 学習中断メッセージモーダル
 */
@Component({
  components: {
    ModalMessage,
  },
})
export default class ModalEscapeStudy extends Vue {
  /** モーダル */
  @Ref()
  private modalMessage!: ModalMessage

  /**
   * ボタン押下時のイベント
   */
  private eventSubmit(): void {
    this.modalMessage.hide()
  }

  /**
   * モーダルを開く
   */
  public show(): void {
    this.modalMessage.show()
  }
}
